import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'

export const useCta1 = props => {
	const { metaData } = props
	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const { handleFocus: handleButtonClick } = useFieldFocus({ metaData: metaData.buttonAction })
	const { handleFocus: handleAdditionalClick } = useFieldFocus({ metaData: metaData.additionalText })

	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	const { editable: additionalTextEditable, handleChange: handleAdditionalTextChange } = useEditorMeta({
		metaData: metaData.additionalText,
		key: 'additionalText',
	})

	const { editable: buttonTextEditable, handleChange: handleButtonTextChange } = useEditorMeta({
		metaData: metaData.buttonText,
		key: 'buttonText',
	})

	return [
		{
			additionalPosition: metaData.additionalPosition?.metaValue,
			mobileAlignment: metaData.mobileAlignment?.metaValue,
			mobileButtonWidth: metaData.mobileButtonWidth?.isWide ? '100%' : 'auto',

			text: metaData.text?.metaValue,
			textKey: metaData.text?.tierKey,
			textConfig: metaData.text?.config,
			textEditable,

			additionalText: metaData.additionalText?.metaValue,
			additionalTextKey: metaData.additionalText?.tierKey,
			additionalTextConfig: metaData.additionalText?.config,
			additionalTextEditable,

			buttonText: metaData.buttonText?.metaValue,
			buttonTextKey: metaData.buttonText?.tierKey,
			buttonTextConfig: metaData.buttonText?.config,
			buttonLink: metaData.buttonLink?.metaValue,
			buttonAction: metaData.buttonAction?.metaValue,

			buttonTextEditable,
		},
		{
			handleTextClick,
			handleButtonClick,
			handleAdditionalClick,
			handleTextChange,
			handleAdditionalTextChange,
			handleButtonTextChange,
		},
	]
}
